<template>
    <div>
        <div class="kb-message"
             :class="[message.sender === 'advisor' ? 'kb-reverse' : '']"
             v-if="message.type === 'image'">
            <img @click="openPhotoSwype()"
                 :src="message.media"
                 style="border-radius: 4px; cursor: pointer; max-width: 50%">
        </div>

        <div class="kb-message"
             :class="[styles.direction]">

            <v-avatar :color="styles.color"
                      :class="message.sender !== 'user' && message.sender !== 'listener' ? 'ml-2' : 'mr-2'"
                      size="30">
                <v-icon size="15">
                    {{styles.icon}}
                </v-icon>
            </v-avatar>

            <div :class="[styles.inOut]"
                 class="overflow-hidden pt-1"
                 style="text-overflow: ellipsis">
                <strong style="color: #4e874e; margin: 6px 6px;"
                        v-if="message.sender === 'advisor' && message.advisorName">
                  {{message.advisorName}}
                </strong>
                <span v-if="youtubeLink">
                    <YoutubePlayer :src="youtubeLink[1]"/>
                </span>
                <div style="text-align: center"
                     v-if="showMediaMessage()">
                    <span v-if="message.type === 'ptt' || message.type === 'ogg' || message.type === 'audio'">
                      <AudioPlayer :src="message.media"/>
                    </span>

                    <span v-else-if="message.type === 'video'">
                      <VideoPlayer :src="message.media"/>
                    </span>

                    <span v-else>
                        <a :href="getMedia().url"
                           target="_blank"
                           :style="{color: getMedia().color}"
                           style="text-decoration: none">
                            <span class="mdi"
                                  :class="[getMedia().icon]"
                                  style="font-size: 60px">
                            </span>
                        </a>
                    </span>

                    <div class="kb-divider"></div>

                  <a class="font-weight-bold px-3"
                     :href="getMedia().url"
                     target="_blank"
                     v-if="this.message.type === 'others'">
                    Enlace de archivo
                  </a>
                </div>

                <div class="kb-message-text"
                     v-html="parseText()"
                     v-if="message.type !== 'status'">
                </div>

                <div class="kb-message-text font-weight-bold"
                     v-if="message.type === 'status' && message.payload"
                     v-html="message.payload.selectedOption">
                </div>

                <div class="kb-message-date-container kb-caption kb-reverse">
                    {{getDate(message.createdAt)}}
                    <span class="message-status mdi"
                          :class="statusIcon"
                          @click="$emit('resend')"
                          v-if="message.sender === 'advisor'">
                    </span>
                </div>
            </div>
        </div>

<!--        <div class="kb-helpers-container" v-if="message.payload">-->
        <div class="kb-helpers-container" v-if="message.payload">
            <KBHelper :payload="message.payload"></KBHelper>
        </div>
    </div>
</template>

<script>
import AudioPlayer from '@/pages/App/Conversations/components/AudioPlayer.vue'
import VideoPlayer from '@/pages/App/Conversations/components/VideoPlayer.vue'
import YoutubePlayer from '@/pages/App/Conversations/components/YoutubePlayer'
import { EmojiConvertor } from 'emoji-js'
import KBHelper from '@/pages/App/Conversations/KBHelper.vue'
import moment from 'moment'

export default {
  components: { AudioPlayer, KBHelper, VideoPlayer, YoutubePlayer },
  computed: {
    styles () {
      if (this.message.sender === 'advisor') return { direction: 'kb-reverse', inOut: 'kb-message-out', color: '#cdefe8', icon: 'mdi-face-agent' }
      if (this.message.sender === 'bot') return { direction: 'kb-reverse', inOut: 'kb-message-out', color: '#cdefe8', icon: 'mdi-robot' }
      if (this.message.sender === 'listener') return { direction: '', inOut: 'kb-message-in', color: '#e8effb', icon: 'mdi-account-clock-outline' }
      return { direction: '', inOut: 'kb-message-in', color: '#e8effb', icon: 'feather-user' }
    },
    statusIcon () {
      return this.message.status === 'sending' ? 'mdi-clock error--text' : 'mdi-check-all'
    },
    youtubeLink () {
      if (this.message.text !== undefined && this.message.text !== '') {
        const regex = /youtu(?:.*\/v\/|.*v=|\.be\/)([A-Za-z0-9_-]{11})/
        const urlVideo = this.message.text.match(regex)
        if (urlVideo && urlVideo.length > 0) {
          return urlVideo
        }
      }
      return false
    }
  },
  methods: {
    getDate (date) {
      return moment(date).locale(this.$root.$i18n.locale).calendar(null, {
        sameElse: 'DD/MM/YYYY HH:mm'
      })
    },
    getMedia () {
      if (this.message.type === 'video' || this.message.type === 'video') { return { icon: 'mdi-video', url: this.message.media } }

      if (this.message.type === 'ptt') return { icon: 'mdi-microphone', url: this.message.media }

      if (this.message.type === 'location') {
        return {
          icon: 'mdi-map-marker',
          url: `https://www.google.com/maps/search/?api=1&query=${this.latitude()},${this.longitude()}`
        }
      }

      const values = this.message.media.split('.')
      let icon = 'mdi-link'
      let color = 'grey'

      if (values.length > 0 && values[values.length - 1] === 'pdf') {
        icon = 'mdi-file-pdf-outline'
        color = '#c31630'
      }

      return {
        color,
        icon,
        url: this.message.media
      }
    },
    latitude () {
      return this.message.media.split(';')[0]
    },
    longitude () {
      return this.message.media.split(';')[1]
    },
    openPhotoSwype () {
      this.$store.dispatch('setPictureInPhotoSwipe', this.message.media)
    },
    parseText () {
      const emoji = new EmojiConvertor()
      emoji.img_sets.apple.path = 'https://unicodey.com/js-emoji/build/emoji-data/img-apple-64/'
      emoji.replace_mode = 'img'
      emoji.supports_css = false

      let originalText = this.message.text

      if (!originalText) return ''

      originalText = originalText.replace(/</igm, '&lt;').replace(/>/igm, '&gt;')
      originalText = originalText.replace(/"/, '&quot;').replace(/'/, '&apos;')

      originalText = emoji.replace_unified(originalText)

      return originalText
    },
    showMediaMessage () {
      return this.message.type === 'video' ||
        this.message.type === 'audio' ||
        this.message.type === 'pdf' ||
        this.message.type === 'ptt' ||
        this.message.type === 'location' ||
        this.message.type === 'others'
    }
  },
  props: {
    message: {
      default: () => ({}),
      type: Object
    }
  }
}
</script>

<style>
    .kb-helpers-container {
        margin-bottom: 6px;
    }

    .kb-message-date-container {
        display: flex;
        align-items: center;
        padding-left: 12px;
        padding-right: 12px;
    }

    .kb-caption {
        font-size: 11px !important;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        letter-spacing: 0.0333333333em !important;
        line-height: 17px;
    }

    .message-status {
        margin-right: 5px;
    }

    img.emoji {
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
    }

    .kb-message-in {
        background-color: #e8effb;
        border-radius: 5px;
        max-width: 100%;
        width: max-content;
    }

    .kb-message-out {
        background-color: #cdefe8;
        border-radius: 5px;
        max-width: 100%;
        width: max-content;
    }

    .kb-message {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        padding-left: 12px;
        padding-right: 12px;
        position: relative;
        margin-bottom: 6px;
    }

    .kb-message-text {
        padding: 1px 7px 0 9px;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-word;
    }

    .kb-message-text a {
        color: #039be5;
        text-decoration: none;
    }

    .kb-message-text a:hover {
        text-decoration: underline;
    }

    .kb-reverse {
        flex-direction: row-reverse;
    }
</style>
